import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { SnackbarProvider } from "@walmart-web/livingdesign-components";
import 'core-js/features/array/at'; // required for react-pdf
import 'rc-tree/assets/index.css';
import 'react-multi-email/dist/style.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configAxios } from './config/axiosConfig';
import analytics from './adobe-analytics/analytics';
configAxios();

export const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

const defineAdobeAnalytics = () => {
  window.__GDMS_PORTAL__ = {
    dataLayer: { analyticsEvent: [] },
  };
  analytics.loadContent(document.getElementsByTagName('head')[0]);
  setTimeout(() => analytics.loadAdobeScript(), 3000);
};

defineAdobeAnalytics();

const renderApp = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ToastContainer {...{ icon: true, hideProgressBar: true, pauseOnHover: true, theme: 'colored' }} />
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

// '@testing-library/react' is not able to detect element with id `root` in DOM.
// To handle this issue, we need to add `document.createElement('div')`;
const root = ReactDOM.createRoot((document.getElementById('root') as HTMLElement) || document.createElement('div'));
root.render(renderApp());

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
